{
  "$schema": "https://cogo.xyz/ontology/v4/expression-accessor-globals",
  "version": "1.0.0",
  "description": "GlobalFn + DollarFn accessor names from expression-accessors-v1.ttl — the call-position identifiers legal at the head of a #{...} expression bareword call (concat(...), $sum(...)), as opposed to a `.method(` accessor (covered separately by VALID_EXPRESSION_METHODS). AUTO-GENERATED by scripts/generate-expression-accessor-globals-json.ts from cogo-kg-browser/fixtures/expression-accessors-v1.ttl (source-of-truth). DO NOT EDIT BY HAND — held byte-identical by src/vocab/__tests__/expression-accessor-globals-derivation.test.ts.",
  "names": [
    "today",
    "monthOffset",
    "formatCurrency",
    "formatCrypto",
    "formatNumber",
    "fromWei",
    "toWei",
    "shortenAddress",
    "timeAgo",
    "cuid",
    "concat",
    "differenceInDays",
    "$map",
    "$filter",
    "$sort",
    "$find",
    "$unique",
    "$sum",
    "$avg",
    "$count",
    "$groupBy"
  ],
  "allNames": [
    "toUpperCase",
    "toLowerCase",
    "trim",
    "includes",
    "startsWith",
    "endsWith",
    "replace",
    "substring",
    "split",
    "toString",
    "toFixed",
    "map",
    "filter",
    "find",
    "reduce",
    "sort",
    "slice",
    "join",
    "length",
    "every",
    "some",
    "unique",
    "today",
    "monthOffset",
    "formatCurrency",
    "formatCrypto",
    "formatNumber",
    "fromWei",
    "toWei",
    "shortenAddress",
    "timeAgo",
    "cuid",
    "concat",
    "differenceInDays",
    "max",
    "min",
    "round",
    "floor",
    "ceil",
    "abs",
    "pow",
    "$map",
    "$filter",
    "$sort",
    "$find",
    "$unique",
    "$sum",
    "$avg",
    "$count",
    "$groupBy"
  ],
  "arrayReturning": [
    "split",
    "map",
    "filter",
    "sort",
    "slice",
    "unique",
    "$map",
    "$filter",
    "$sort",
    "$unique"
  ]
}
